<template>
    <NavbarMain/>

    <PresentationSection :photo="first_section_image_en" :title="first_section_title_en" :content="first_section_content_en"/>

    <CardSection :content-title="second_section_title_en" :content-sentance="second_section_content_en"/>

    <WidePhotoComponent :photo="third_section_image_en" :content="third_section_content_en" />

    <FooterPage/>
</template>

<script>
import axios from 'axios';
import CardSection from '@/components/CardSection.vue';
import FooterPage from '@/components/FooterPage.vue';
import NavbarMain from '@/components/NavbarMain.vue';
import PresentationSection from '@/components/PresentationSection.vue';
import WidePhotoComponent from '@/components/WidePhotoComponent.vue';

export default {
    components: {
        NavbarMain,
        PresentationSection,
        FooterPage,
        WidePhotoComponent,
        CardSection
    },
    data() {
        return {
            complianceData: { items_en: [{}] },
            first_section_image_en: '',
            first_section_title_en: '',
            first_section_content_en: '',
            second_section_title_en: '',
            second_section_content_en: '',
            third_section_image_en: '',
            third_section_content_en: '',
        }
    },
    mounted() {
        const token = process.env.VUE_APP_WEBSITE_TOKEN;
        const API_URL = process.env.VUE_APP_WEBSITE_HOSTNAME;

        axios.get(`${API_URL}/api/compliance-content`, {
            headers: {
                'Authorization': `Token ${token}`,
            },
        })
            .then(response => {
                this.complianceData = response.data || { items_en: [] };

                if (this.complianceData.items_en[0]?.active === true) {
                    this.first_section_image_en = this.complianceData.items_en[0].first_section_image;
                    this.first_section_title_en = this.complianceData.items_en[0].first_section_title;
                    this.first_section_content_en = this.complianceData.items_en[0].first_section_content;
                    this.second_section_title_en = this.complianceData.items_en[0].second_section_title;
                    this.second_section_content_en = this.complianceData.items_en[0].second_section_content;
                    this.third_section_image_en = this.complianceData.items_en[0].third_section_image;
                    this.third_section_content_en = this.complianceData.items_en[0].third_section_content;
                }
            })
            .catch(error => {
                console.error('Error fetching Compliance data:', error);
            });
    }
}
</script>

<style>
</style>
